var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJewelry = function SvgJewelry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M36.48 5.28H11.52a3.67 3.67 0 0 0-2.914 1.577l-6.24 8.64a3.6 3.6 0 0 0 .205 4.423l18.72 21.566a3.43 3.43 0 0 0 5.418 0l18.72-21.566a3.6 3.6 0 0 0 .205-4.423l-6.24-8.64A3.67 3.67 0 0 0 36.48 5.28"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m22.217 5.246-8.366 12.96L24 42.72m1.886-37.474 8.331 12.96L24 42.72M1.783 18.206h44.434"
  }))));
};
export default SvgJewelry;